module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.rowData.combo.length > 0) ? _c('div', {
    staticClass: "combo-detail"
  }, [_vm._m(0), _vm._l((_vm.rowData.combo), function(pair) {
    return _c('div', {
      staticClass: "one-med"
    }, [_c('div', {
      attrs: {
        "id": "medication_generic_name"
      }
    }, [_vm._v(_vm._s(pair.medication.generic_name) + " ")]), _c('div', {
      staticClass: "text-center",
      attrs: {
        "id": "dose"
      }
    }, [_vm._v(_vm._s(pair.dose))]), _c('div', {
      staticClass: "text-center",
      attrs: {
        "id": "action"
      }
    }, [_c('button', {
      staticClass: "btn btn-danger btn-sm",
      on: {
        "click": function($event) {
          return _vm.deleteFromCombo(pair.relation_id)
        }
      }
    }, [_vm._v("刪除")])])])
  })], 2) : _vm._e(), _c('span', [_vm._v("新增藥物至此套藥組")]), _c('form', {
    staticClass: "form-inline",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.addDrugToCombo($event)
      }
    }
  }, [_c('div', {
    staticClass: "search-dynamic",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "input-group mr-2"
  }, [_vm._m(1), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchDrug),
      expression: "searchDrug"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "輸入藥碼, 學名或料位號"
    },
    domProps: {
      "value": (_vm.searchDrug)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchDrug = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "input-group mr-2"
  }, [_vm._m(2), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dose),
      expression: "dose"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "輸入預設劑量",
      "type": "number",
      "min": "1"
    },
    domProps: {
      "value": (_vm.dose)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dose = $event.target.value
      }
    }
  })]), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "disabled": _vm.pairAddable === false
    }
  }, [_vm._v("新增")]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.searchMedicines.length !== 0),
      expression: "searchMedicines.length !== 0"
    }],
    staticClass: "input-options-wrap"
  }, _vm._l((_vm.searchMedicines), function(med, num) {
    return _c('div', {
      staticClass: "input-option",
      on: {
        "click": function($event) {
          return _vm.setMedicine(num)
        }
      }
    }, [_vm._v(_vm._s(med.code) + " - " + _vm._s(med.CGMH_number) + " - " + _vm._s(med.generic_name) + "    ")])
  }), 0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "combo-detail--head"
  }, [_c('div', [_vm._v("藥物名稱")]), _c('div', {
    staticClass: "text-center"
  }, [_vm._v("數量")]), _c('div', {
    staticClass: "text-center"
  }, [_vm._v("刪除")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("藥物")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("劑量")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-307390c0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/SystemSettings/ComboDetail.vue
// module id = 1423
// module chunks = 1